export default "__VITE_ASSET__QSb$jgCt__"